import React from 'react';
import useGetRuleColumns, { Args } from 'Hooks/useGetRuleColumns';
import useRuleView from 'Hooks/useRuleView';
import useLatestDeploy from 'Hooks/query-hooks/useLatestDeploy';
import { GLOBAL_RULE_TABLE_VIEW } from 'Common/enums';
import useGetLandlordInfo from 'Hooks/query-hooks/tenant/useGetLandlordInfo';
import CommonGlobalRulesTable from 'Components/GlobalRulesTable';
import { useSelector } from 'react-redux';
import { getUser } from 'Selectors';
import { getRulesFormatForView } from 'Utils';

const DeployedGlobalRulesTable = ({
    rulesData,
    allowOverride,
    isLandlordDeployment,
    sandboxRules
}: {
    rulesData: Rule[];
    allowOverride?: boolean;
    isLandlordDeployment?: boolean;
    sandboxRules?: Rule[];
}) => {
    const { viewOption, setViewOption } = useRuleView();
    const isGlobalRuleSelectOption = viewOption === GLOBAL_RULE_TABLE_VIEW;
    const globalColumns: Args['columns'] = [
        'virtualRuleGroup',
        'ruleId',
        'inputDescription',
        'conclusion',
        'ruleType',
        'lastModified',
        'status'
    ];
    const executionColumns: Args['columns'] = [
        'modifiedFlag',
        'executionOrder',
        'ruleId',
        'inputDescription',
        'ruleGroup',
        'conclusion',
        'ruleType',
        'status'
    ];
    const deployedRuleColumns = isGlobalRuleSelectOption ? globalColumns : executionColumns;
    const { data, isInitialLoading } = useLatestDeploy(undefined, !isLandlordDeployment);
    const { data: landlordInfo } = useGetLandlordInfo(!isLandlordDeployment);
    const { tenantKey, landlordId } = useSelector(getUser);
    const isImpersonationMode = landlordId && landlordId !== tenantKey;

    const mode = allowOverride ? 'overrides' : 'deployed';

    if (landlordInfo?.isLandlord) {
        globalColumns.push('allowOverrides');
    }
    if (landlordInfo?.isLandlord || isImpersonationMode) {
        globalColumns.push('hiddenFromTenant');
    }

    const columnNames = useGetRuleColumns({
        columns: deployedRuleColumns
    });
    // Default or Templated Rules should not be seen in Execution Order view.
    const formatedRulesData = getRulesFormatForView(rulesData, isGlobalRuleSelectOption);

    return (
        <CommonGlobalRulesTable
            deploymentVersion={isLandlordDeployment ? undefined : data?.version}
            tableName={`${tenantKey}-deployed-global-rules`}
            rulesData={formatedRulesData}
            columnNames={columnNames}
            mode={mode}
            groupByColumns={['virtualRuleGroup']}
            sandboxRules={sandboxRules}
            selectViewOption={viewOption}
            setSelectViewOption={setViewOption}
            options={{
                allowOverride,
                isLandlordDeployment,
                isLoading: isInitialLoading,
                isRevisionHistoryVisible: true
            }}
        />
    );
};

export default DeployedGlobalRulesTable;
